import { render, staticRenderFns } from "./documents-manage.vue?vue&type=template&id=024cfd04"
import script from "./documents-manage.vue?vue&type=script&lang=ts"
export * from "./documents-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports